var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "audio_preview_wrap" }, [
    _c("div", { staticClass: "audio_preview_box" }, [
      _c("div", { staticClass: "audio_head" }, [
        _c("p", { staticClass: "audio_name" }, [_vm._v(_vm._s(_vm.audioName))]),
        _vm._v(" "),
        _c("span", {
          staticClass: "el-icon-circle-close close_btn",
          on: {
            click: function($event) {
              return _vm.closeFn()
            }
          }
        })
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "video_wrap" }, [
        _c("audio", {
          ref: "audio",
          attrs: {
            src: _vm.audioSrc,
            controls: "controls",
            autoplay: "autoplay"
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "imgbg" }, [
      _c("img", {
        attrs: {
          src: require("../../../../../../static/images/newCourse/audioBg.png")
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4721c092", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4721c092","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_course_module/editCourse/sourceMaterial/audioView.vue
// module id = null
// module chunks = 